import { JourneysLegacyRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { Navigate } from '@/utils/navigate';

function UsersRoute() {
  const { _splat } = Route.useParams();
  // Legacy `/users/login` (Unity) → canonical Hydra `/login`. Everything else
  // under /users stays with the embedded app.
  if ((_splat ?? '').split('/')[0] === 'login') {
    // Preserve any query params (e.g. `?origin`, `?token`) the legacy link carried.
    const search = Object.fromEntries(new URLSearchParams(window.location.search));
    return <Navigate to="/login" replace={true} search={search} />;
  }
  return <JourneysLegacyRoute />;
}

export const Route = createFileRoute('/users/$')({
  component: UsersRoute,
});
